// extracted by mini-css-extract-plugin
export default {"root":"articleLabel_root__BHWo6","checked":"articleLabel_checked__edRdM","title":"articleLabel_title__cLbRf"};